<!-- LanguageSwitcher.vue -->
<template>
	<div class="language-selector">
		<button @click="toggleLanguageDropdown">
			<img src="../../assets/Globe/iconeGlobo.svg" />
		</button>
		<ul
			v-if="showDropdown"
			class="language-dropdown"
		>
			<li
				v-for="(label, lang) in languages"
				:key="lang"
				@click="changeLanguage(lang)"
			>
				{{ label }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showDropdown: false,
			languages: {
				en: 'English',
				ptbr: 'Português',
				es: 'Español',

				// Adicione mais idiomas conforme necessário
			},
		}
	},
	methods: {
		toggleLanguageDropdown() {
			this.showDropdown = !this.showDropdown
		},
		changeLanguage(lang) {
			this.$i18n.locale = lang
			localStorage.setItem('idioma', lang)
			this.$forceUpdate()
			this.showDropdown = false
			window.location.reload()
		},
	},
}
</script>

<style scoped>
.language-selector {
	position: relative;
	display: inline-block;
	margin-top: 5px;
}

.language-dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	list-style-type: none;
	padding: 0;
	margin: 0;
	background-color: #fff;
	border: 1px solid #ccc;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	z-index: 1;
	border-radius: 5px;
}

.language-dropdown li {
	padding: 10px;
	cursor: pointer;
}

.language-dropdown li:hover {
	background-color: #f0f0f0;
}
</style>
